import resolution from "res";
import { canUseDOM } from "fbjs/lib/ExecutionEnvironment";

const imageRequest = require.context("assets/images", false, /\.(jpg|png)$/);
const svgRequest = require.context("assets/images", false, /\.(svg)$/);
const soundRequest = require.context("assets/sounds", false, /\.(aif|mp3)$/);

export default function assetPath(assetName, assetExtension = "jpg") {
  // Create path
  let path = null;
  let privateResolution = 2;

  // Set resolution if possible
  if (canUseDOM) {
    privateResolution = _.min([_.toInteger(resolution.dppx()), 3]);
    privateResolution = _.max([privateResolution, 1]);
  }

  // Return correct path
  if (
    is.equal(assetExtension, "jpg") ||
    is.equal(assetExtension, "jpeg") ||
    is.equal(assetExtension, "png")
  ) {
    path = imageRequest(
      `./${assetName}@${privateResolution}x.${assetExtension}`
    );
  }

  // Return correct path
  if (is.equal(assetExtension, "svg")) {
    path = svgRequest(`./${assetName}.${assetExtension}`);
  }

  // Return correct path
  if (is.equal(assetExtension, "aif") || is.equal(assetExtension, "mp3")) {
    path = soundRequest(`./${assetName}.${assetExtension}`);
  }

  // Return path
  return path;
}



// WEBPACK FOOTER //
// ./src/utils/assetPath.js